import { ADD_SUBJECT_UPDATE_ID, REMOVE_SUBJECT_UPDATE_ID } from "actions/subjects";
import initialState from "store/initialState";

const updateIds = (state = initialState.updateIds, action: any) => {
  switch (action.type) {
    case ADD_SUBJECT_UPDATE_ID:
      return [...state, action.payload];
    case REMOVE_SUBJECT_UPDATE_ID:
      const idx = state.indexOf(action.payload);
      if (idx > -1) {
        return state.filter((_, i) => i !== idx);
      } else return state;
    default:
      return state;
  }
};

export default updateIds;
